import { render, staticRenderFns } from "./CustomerTabContent.vue?vue&type=template&id=520d965a"
import script from "./CustomerTabContent.vue?vue&type=script&lang=js"
export * from "./CustomerTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports